import React, { Component, useRef } from 'react';
import { Mutation } from 'react-apollo';
import { ADD_JOB, LIST_JOB, POSTS_COUNT, DIST_USER } from './queries';
import { Multiselect } from 'multiselect-react-dropdown';
import { constRef } from "../constants";

class PostAJob extends Component {
  constructor() {
    super();
    this.multiselectRef = React.createRef();
  }
  state = {
    title: '',
    description: '',
    status: '',
    budget: '',
    currency: '',
    user: '',
    time: '',
    contact: '',
    skills: '',
    options: constRef.optionsRef,
    defaultValues: [],
    submitStyle: "btn btn-primary btn-xxl",
    postButtonText: "Post Job"

  }

  handleSkillChange = (skills) => {
    let sk = [];
    sk = Array.from(document.getElementById("multiskills").options).filter(option => option.selected && option.value !== 'Add Skills').map(option => option.value);
    this.setState({ skills: sk.toString() });
  }

  onSelect = (skills, selectedItem) => {
    this.setState({ skills: skills.toString() });
  }

  onRemove = (skills, selectedItem) => {
    this.setState({ skills: skills.toString() });
  }


  handleSubmit = (addJob) => {
    if (this.state.title && this.state.budget !== '' && this.state.skills !== '') {

      addJob({
        variables: {
          title: this.state.title,
          description: this.state.description,
          status: 'OPEN',
          budget: this.state.budget,
          currency: this.state.currency === '' ? 'INR' : this.state.currency,
          user: this.state.user,
          time: new Date().toLocaleString(),
          contact: this.state.contact,
          skills: this.state.skills
        }, refetchQueries: [{ query: LIST_JOB }, { query: POSTS_COUNT }, { query: DIST_USER }]
      })
      this.setState({
        title: '',
        description: '',
        status: '',
        budget: document.getElementById('budget').options[0],
        currency: '',
        user: '',
        time: '',
        contact: '',
        skills: ''
      });
      this.resetValues();
      this.setState({
        submitStyle: "btn btn-success btn-xxl",
        postButtonText: "Job Posted Successfully!!!"
      });
    }
    else {
      //alert('Please fill mandatory fields like budget, skills');
      this.setState({
        submitStyle: "btn btn-danger btn-xxl",
        postButtonText: "Error-mandatory Fields(budget or skills)"
      });
    }
  }
  resetValues = () => {
    this.multiselectRef.current.resetSelectedValues();
  }
  resetStyles = () => {
    this.setState({
      submitStyle: "btn btn-primary btn-xxl",
      postButtonText: "Post Job"
    });
    this.setState({
      title: '',
      description: '',
      status: '',
      budget: document.getElementById('budget').options[0],
      currency: '',
      user: '',
      time: '',
      contact: '',
      skills: ''
    });
    this.resetValues();
  }
  render() {
    return (
      <div>
        <Mutation mutation={ADD_JOB}>
          {(addJob, { data }) => (
            <div className="container">
              <form id="postform" onSubmit={e => {
                e.preventDefault();
                this.state.submitStyle = this.handleSubmit(addJob);
              }}
                className="form-group form-group-lg"
              >

                <input required type="text" placeholder="Enter Title" className='form-control' onChange={e => this.setState({ title: e.target.value })} value={this.state.title} /><br />
                <textarea required rows="6" className='form-control' placeholder="Enter Description" onChange={e => this.setState({ description: e.target.value })} value={this.state.description} /><br />
                <div className="form-row">
                  <div className="col-8">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="inputGroupPrepend-1"><i className="fa fa-money fa-2x" aria-hidden="true"></i></span>
                      </div>
                      <select required id="budget" value={this.state.budget} className='form-control' onChange={e => e.target.value !== 'Select Budget' ? this.setState({ budget: e.target.value }) : ''}>
                        <option value="Select Budget">Select Budget</option>
                        <option value="100 - 250">100 - 250</option>
                        <option value="250 - 500">250 - 500</option>
                        <option value="500 - 1000">500 - 1000</option>
                        <option value="1000 - 2000">1000 - 2000</option>
                        <option value="2000 - 5000">2000 - 5000</option>
                        <option value="5000 - 10000">5000 - 10000</option>
                        <option value="10000 - 50000">10000 - 50000</option>
                        <option value="50000 - 100000">50000 - 100000</option>
                        <option value="100000 - 1000000">100000 - 1000000</option>
                      </select>

                    </div>
                  </div>
                  <div className="col">
                    <select required defaultValue="INR" className='form-control' onChange={e => this.setState({ currency: e.target.value })}>
                      <option value="INR">INR</option>
                      <option value="USD">USD</option>
                      <option value="AUD">AUD</option>
                      <option value="AUD">CAD</option>
                    </select>
                  </div>
                </div><br />

                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroupPrepend-2"><i className="fa fa-user fa-2x" aria-hidden="true"></i></span>
                  </div>
                  <input required type="text" placeholder="Username" className='form-control' onChange={e => this.setState({ user: e.target.value })} value={this.state.user} /><br />
                </div> <br />
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroupPrepend-3"><i className="fa fa-phone-square fa-2x" aria-hidden="true"></i></span>
                  </div>
                  <input required type="text" placeholder="WhatsApp Contact" className='form-control' onChange={e => this.setState({ contact: e.target.value })} value={this.state.contact} /><br />

                </div> <br />

                <div className="input-group">
                  <Multiselect id="multiskills" required
                    options={this.state.options}
                    displayValue="key"
                    selectedValues={this.state.defaultValues}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    placeholder="Add Skills"
                    isObject={false}
                    style={constRef}
                    ref={this.multiselectRef}
                  />
                </div>

                <br />


                <div className="float-right">
                  <button type="reset" onClick={this.resetStyles} className="btn btn-primary btn-xxl">Reset</button>
                </div>
                <div className="float-right">
                  <button type="submit" className={this.state.submitStyle}>{this.state.postButtonText}</button>
                </div>

              </form>
            </div>
          )
          }
        </Mutation>
      </div>
    )
  }
}


export default PostAJob
